import 'smartbanner.js';

document.addEventListener(
    'smartbanner.view',
    () => {
        const button = document.querySelector('.js_smartbanner__button');
        const { clickQueryParam, isAuthenticated } = window.__VUMEDI_SMARTBANNER_CONTEXT__;

        button.addEventListener('click', async (event) => {
            event.preventDefault();
            const { viewedUUID } = window.__VUMEDI_TRACKING_EVENT_CONTEXT__;
            const url = new URL(window.location);

            if (isAuthenticated === true) {
                await window.vumedi.mixpanel?.track('SmartBannerClick');
            }
            url.searchParams.set(clickQueryParam, true);
            url.searchParams.set('viewed_uuid', viewedUUID);
            // Simply changing the location to the current one is not working with universal linking.
            // Removing www from the URL will trigger redirection on the Nginx side and universal linking will work.
            window.location = url.href.replace('https://www.', 'https://');
        });

        // Tracking
        if (isAuthenticated === true) {
            window.vumedi.mixpanel?.track('SmartBannerDisplay');
            document.addEventListener(
                'smartbanner.exit',
                () => {
                    window.vumedi.mixpanel?.track('SmartBannerDismiss');
                },
                { once: true },
            );
        }
    },
    { once: true },
);
